import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import FetchSelect from '../../../core/form/FetchSelect';
import LocalFileInput from '../../../core/form/LocalFileInput';
import FormButtons from '../../../core/form/FormButtons';
import { Roles } from '../../../core/util';

const ModuleCustomizationForm = (props) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      props.onSubmit();
    }}
  >
    <Row>
      {localStorage.role === Roles.ADMIN && (
        <Column size={8}>
          <FetchSelect
            required
            url="distributors"
            label="Distributor"
            disabled={props.submitting}
            value={get(props.values, 'distributor', '')}
            onChange={(value) => props.onChange('distributor', value)}
            resultTransformer={{ text: 'name', value: 'id' }}
            errorText={get(props.errors, 'distributor', null)}
          />
        </Column>
      )}
    </Row>
    <Row>
      <Column size={4}>
        <FetchSelect
          required
          url="/courses"
          label="Course"
          disabled={props.submitting}
          value={get(props.values, 'course', '')}
          onChange={(value) => {
            props.onChange('course', value);
            props.onChange('module', undefined);
            props.onChange('file', undefined);
          }}
          resultTransformer={{ text: 'name', value: 'id' }}
          errorText={get(props.errors, 'course', null)}
        />
      </Column>
      <Column size={8}>
        <FetchSelect
          required
          url="/modules"
          label="Module"
          placeholder="Select a course to enable modules"
          disabled={props.submitting || !get(props.values, 'course', false)}
          value={get(props.values, 'module', '')}
          onChange={(value) => props.onChange('module', value)}
          params={{
            ...(get(props.values, 'course', false) && { query: { course: get(props.values, 'course', '') } }),
          }}
          sortCondition={['group', 'order']}
          resultTransformer={{
            text: 'name',
            value: 'id',
            textFunc: (row) => `${row.group} - ${row.order} - ${row.name}`,
          }}
          errorText={get(props.errors, 'module', null)}
        />
      </Column>
    </Row>
    <Row>
      <Column size={12}>
        <LocalFileInput
          required
          label="Icon"
          buttonLabel="Select an image"
          accept="image"
          disabled={props.submitting || !get(props.values, 'module', false)}
          value={get(props.values, 'file', null)}
          onChange={(file) => props.onChange('file', file)}
          errorText={get(props.errors, 'file', null)}
        />
      </Column>
    </Row>
    <FormButtons
      confirmLabel="Create Module Customization"
      isDisabled={props.submitting || !props.isDirty()}
      isSubmitting={props.submitting}
      onReset={props.onReset}
    />
  </form>
);

ModuleCustomizationForm.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func,
};

ModuleCustomizationForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  isDirty: () => false,
  onReset: () => false,
};

export default ModuleCustomizationForm;
